<ngx-doc-viewer url="{{src}}" style=" height: 100vh;width: 100vw;padding: 18px 20%;margin: auto;z-index: 99999999999;"></ngx-doc-viewer>